import { makeStyles } from 'tss-react/mui';

const useStylesCheckboxLabel: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  checkboxLabelFullWidth: {
    width: '100%',
  },
  checkboxLabelDark: {
    color: `${theme.palette.common.white} !important`,
    backgroundColor: `${theme.palette.primary.main} !important`,
  },
}));

export default useStylesCheckboxLabel;
